var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.899902 3.59998V8.09998H8.0999V3.59998L4.4999 6.29998L0.899902 3.59998Z",
    fill: "#084864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.899902 3.60002H8.0999L4.4999 0.900024L0.899902 3.60002Z",
    fill: "#084864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.cb882793fb2cde3206516af09bda6ecd.svg";
export { ForwardRef as ReactComponent };